<script setup>

import Dropdown from 'primevue/dropdown';

const { typeObjet, typesObjet, valeurOblig, desactive, placeholder } = defineProps({
    typeObjet: Object,
    typesObjet: Array,
    valeurOblig: Boolean,
    desactive: Boolean,
    placeholder: String
});

const emit = defineEmits(['update:typeObjet']);

function modifierTypeObjet(typeObjet) {
    emit('update:typeObjet', typeObjet);
}

</script>

<template>
    <Dropdown 
      :modelValue="typeObjet" 
      :options="typesObjet" 
      optionLabel="libelle"
      :placeholder="valeurOblig ? placeholder : 'Aucun'"
      :showClear="valeurOblig ? false : true"
      :disabled="desactive"
      @change="modifierTypeObjet($event.value)"/>
</template>

<style scoped>

</style>